import axios from 'axios'

const axiosApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/v1'
});

axiosApi.interceptors.request.use(
  config => {
    const token = localStorage.getItem('@bizmob-token');
    if (token) {
      config.headers['x-token'] = token
    }

    return config
  }
)

export default axiosApi